<template>
  <div id="view">
    <div>
      <!-- Header -->
      <header class="header-content">
        <div class="header-left">
          <div class="header-content-box menu-logo" @click="handleMenuClick">
            <img
              src="@/assets/img/menu_logo.png"
              alt="Company Logo"
              class="logo"
            />
          </div>
          <div class="header-content-box" @click="goHome">
            <img src="@/assets/logo.png" alt="Company Logo" class="logo" />
          </div>
        </div>
        <div class="header-right">
          <div class="login-box">
            <button class="login-button1" @click="goLink('register')">
              <img
                src="@/assets/avatar_placeholder.png"
                alt="avatar"
                class="avatar-icon"
              />注册
            </button>
            <button class="login-button2" @click="goLink('login')">登录</button>
          </div>
        </div>
      </header>

      <!-- Main Content -->
      <main class="main-content">
        <!-- 首页 -->
        <section v-if="activeMainTab === 0" class="main-content-box">
          <MobileHomeView />
        </section>
        <!-- 文档中心 -->
        <section v-if="activeMainTab === 1">
          <!-- 应用开发 -->
          <AppDevelopment @sendData="getDocMenuData" />
        </section>
        <!-- 表盘设计 -->
        <section v-if="activeMainTab === 2">
          <DialDesign @sendData="getDocMenuData" />
        </section>
        <!-- 穿戴设备接入 -->
        <section v-if="activeMainTab === 3">
          <DeviceView @sendData="getDocMenuData" />
        </section>
        <!-- 平台说明 -->
        <section v-if="activeMainTab === 5">
          <PlatformDescription @sendData="getDocMenuData" />
        </section>
      </main>
      <div class="footer_all">
        <div class="webMap">
          <div class="left">
            <img
              src="@/assets/img/web_map/web_map1.png"
              alt="webMap"
              style="width: 150px; height: 30px; cursor: pointer"
              @click="goHyperLink('https://www.openatom.org/')"
            />
            <img
              src="@/assets/img/web_map/web_map2.png"
              alt="webMap"
              style="width: 151px; height: 32px; cursor: pointer"
              @click="goHyperLink('https://www.openharmony.cn/mainPlay')"
            />
            <img
              src="@/assets/img/web_map/web_map3.png"
              alt="webMap"
              style="width: 162px; height: 26px; cursor: pointer"
              @click="goHyperLink('https://gitee.com/cooperation-team-L0UI')"
            />
          </div>
          <div class="right">
            <div class="wechat">
              <img
                src="@/assets/img/web_map/web_map4.png"
                alt="webMap"
                style="width: 46px; height: 46px"
              />
              <div class="wechat-text">鸿信智联公众号</div>
            </div>
            <div class="platform">
              <img
                src="@/assets/img/web_map/platform_img.png"
                alt="webMap"
                style="width: 46px; height: 46px"
              />
              <div class="platform-text" style="margin-top: 6px">
                OpenHarmony
              </div>
              <div class="platform-text">智能穿戴聚合平台</div>
            </div>
          </div>
        </div>
        <!-- 底部备案号 -->
        <div class="recordNumber">
          <img
            src="@/assets/img/home_footer_icon.png"
            alt="footer_icon"
            style="width: 24px; height: 24px"
          />
          <div class="footer_text">粤ICP备2024349148号</div>
        </div>
      </div>
    </div>
    <div class="menu-container" v-if="isMenu">
      <div class="left">
        <div class="top-box">
          <div class="top-box-left">
            <img
              src="@/assets/logo.png"
              alt="Company Logo"
              class="logo"
              @click="isMenu = ''"
            />
          </div>
          <div class="top-box-right">
            <img
              src="@/assets/img/quit_icon.png"
              alt="quit"
              @click="isMenu = ''"
            />
          </div>
        </div>
        <el-tree
          class="filter-tree"
          :data="mainMenuData"
          :props="defaultProps"
          default-expand-all
          @node-click="handleNodeClick"
          v-if="isMenu == '1'"
        >
        </el-tree>

        <div class="doc_menu" v-if="isMenu == '2'">
          <div class="back_box">
            <img class="back_img" src="@/assets/img/back_img.png" alt="back" />
            <span class="back_text" @click="isMenu = '1'">返回主菜单</span>
          </div>
          <el-input
            placeholder="搜索"
            v-model="filterText"
            class="search_input"
          >
            <template #prefix>
              <img
                src="@/assets/img/nav_search.png"
                alt="search"
                style="
                  width: 16px;
                  height: 16px;
                  margin-top: 10px;
                  margin-left: 8px;
                "
              />
            </template>
          </el-input>

          <div class="tree_box">
            <el-tree
              class="filter-tree"
              :data="docMenuData"
              :props="defaultProps"
              default-expand-all
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
              ref="tree"
              node-key="id"
            >
              <template #default="{ data }">
                <div
                  :class="{
                    tree_text: true,
                    'text-is-current': data.path === $route.path,
                  }"
                >
                  {{ data.label }}
                </div>
              </template>
            </el-tree>
          </div>
        </div>
      </div>
      <div class="right" @click="isMenu = ''"></div>
    </div>
  </div>
</template>

<script>
import { getAppIconListPage } from "@/api/home";
import MobileHomeView from "./MobileHomeView.vue";
import DeviceView from "./components/DeviceView.vue";
import AppDevelopment from "./components/AppDevelopment.vue";
import DialDesign from "./components/DialDesign.vue";
import PlatformDescription from "./components/PlatformDescription.vue";

export default {
  name: "App",
  components: {
    MobileHomeView,
    DeviceView,
    AppDevelopment,
    DialDesign,
    PlatformDescription,
  },
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mainMenuData: [
        {
          label: "首页",
          path: "/",
        },
        {
          label: "应用开发",
          children: [
            {
              label: "新手指引",
              path: "/apps/overview",
            },
            {
              label: "应用创建与管理",
              path: "/apps/create-app",
            },
            {
              label: "手表应用开发",
              path: "/apps/development-guide",
            },
          ],
        },
        {
          label: "表盘设计",
          children: [
            {
              label: "新手指引",
              path: "/dial/overview",
            },
            {
              label: "表盘创建与管理",
              path: "/dial/create",
            },
            {
              label: "表盘的设计",
              path: "/dial/operating-instructions",
            },
          ],
        },
        {
          label: "穿戴设备接入",
          children: [
            {
              label: "新手指引",
              path: "/device/overview",
            },
            {
              label: "手机手表应用互联开发",
              path: "/device/develop-overview",
            },
            {
              label: "集成应用市场H5",
              path: "/device/market-overview",
            },
          ],
        },
        {
          label: "平台说明",
          children: [
            {
              label: "用户管理",
              path: "/platform/suer-registration",
            },
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
      configUrl: process.env.VUE_APP_SERVER_URL,
      activeMainTab: 0,
      activeTab: 0,
      webUrl:
        "https://watch-app-market.oss-cn-shenzhen.aliyuncs.com/portal/OpenHarmony%E6%89%8B%E8%A1%A8%E5%BA%94%E7%94%A8%E5%BC%80%E5%8F%91%E6%8C%87%E5%AF%BC.pdf",
      isContact: false,
      docIndex: "appDevelopment",
      appIconList: [],
      isMenu: "",
      filterText: "",
      docMenuData: [],
    };
  },
  created() {
    // this.getAppIconList();
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.path === "/") {
          this.activeMainTab = 0;
          this.activeTab = 0;
        } else if (to.path.startsWith("/apps/")) {
          this.activeMainTab = 1;
          const type = to.params.type;
          this.menuClick(type);
        } else if (to.path.startsWith("/dial/")) {
          this.activeMainTab = 2;
        } else if (to.path.startsWith("/device/")) {
          this.activeMainTab = 3;
        } else if (to.path.startsWith("/developer/")) {
          this.activeMainTab = 4;
        } else if (to.path.startsWith("/platform/")) {
          this.activeMainTab = 5;
        } else {
          this.activeMainTab = -1;
        }
      },
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    async getAppIconList() {
      try {
        let data = {
          page: 1,
          pageSize: 10,
        };
        const res = await getAppIconListPage(data);
        this.appIconList = res.data.records || [];
        console.log("iconListPage接口返回:", res);
      } catch (e) {
        console.error("iconListPage接口请求失败:", e);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getDocMenuData(data) {
      console.log("文档菜单数据", data);
      this.docMenuData = data;
    },
    handleNodeClick(data) {
      console.log(data);
      if (data.path && this.$route.path !== data.path) {
        this.$router.replace(data.path);
      }
      this.isMenu = "";
    },
    handleMenuClick() {
      if (this.$route.path === "/") {
        this.isMenu = "1";
      } else {
        this.isMenu = "2";
      }
    },
    menuClick(type) {
      this.docIndex = type;
      if (this.$route.path !== `/apps/${type}`) {
        this.$router.push(`/apps/${type}`).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
      }
      if (type == "appDevelopment") {
        this.isContact = false;
        this.webUrl =
          "https://watch-app-market.oss-cn-shenzhen.aliyuncs.com/portal/OpenHarmony%E6%89%8B%E8%A1%A8%E5%BA%94%E7%94%A8%E5%BC%80%E5%8F%91%E6%8C%87%E5%AF%BC.pdf";
      } else if (type == "h5Integration") {
        this.isContact = false;
        this.webUrl =
          "https://watch-app-market.oss-cn-shenzhen.aliyuncs.com/portal/OpenHarmony%E7%A9%BF%E6%88%B4%E8%81%9A%E5%90%88%E5%B9%B3%E5%8F%B0H5%E9%9B%86%E6%88%90%E6%8C%87%E5%AF%BC.pdf";
      } else if (type == "contactUs") {
        this.isContact = true;
      }
    },
    goDoc(type) {
      if (this.$route.path !== `/apps/${type}`) {
        this.$router.push(`/apps/${type}`).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
      }
    },
    goHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/").catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
      }
    },
    goLink(text) {
      if (text == "register") {
        window.open(`${this.configUrl}/register`);
      } else if (text == "login") {
        window.open(`${this.configUrl}/login`);
      } else if (text == "beian") {
        window.open(`https://beian.miit.gov.cn/#/Integrated/index`);
      }
    },
  },
};
</script>

<style scoped>
body {
  width: 100%;
  margin: 0;
  font-family: Arial, sans-serif;
  caret-color: transparent;
}

#view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.doc_menu {
  height: calc(100% - 90px);
}

.tree_box {
  height: calc(100% - 96px);
  overflow-y: auto;
}

/* 菜单栏样式 */
.filter-tree {
  margin-top: 32px;
  font-weight: 500;
  font-size: 14px;
  color: #1f2937;
  text-align: left;
}

::v-deep .el-input__inner::placeholder {
  font-weight: 500;
  font-size: 15px;
  color: #6b7280;
  text-align: left;
  padding-left: 4px;
}

::v-deep .filter-tree .el-tree-node__content:hover {
  background-color: transparent;
}

::v-deep .filter-tree .el-tree-node__content {
  background-color: #fff !important;
  height: 36px;
}

::v-deep .el-tree-node__expand-icon {
  color: #1f2937;
}

::v-deep .is-leaf.el-tree-node__expand-icon {
  color: transparent;
}

.header-content {
  box-sizing: border-box;
  width: 100%;
  height: 80px;
  padding: 0 16px;
  border: 1px solid #eaecf0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
}

.header-content-box {
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 12px;
}

.header-content-box.menu-logo {
  width: 38px;
  height: 38px;
  background: #ffffff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #e5e7eb;
}

.menu-logo img {
  width: 16px;
  height: 16px;
}

.logo {
  width: 32px;
  height: 32px;
}

.platform-name {
  font-family: "HarmonyOS Sans SC-Bold";
  font-weight: bold;
  font-size: 16px;
  color: #3b82f6;
  margin: 0;
}

.header-left {
  display: flex;
  flex-direction: row;
}

.header-right {
  display: flex;
  align-items: center;
}

.nav-list {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0 0 0 24px;
}

.nav-list li {
  margin-right: 20px;
  position: relative;
}

.nav-text {
  font-family: "HarmonyOS Sans SC-Medium";
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
  margin-right: 0;
  padding: 8px;
  border-radius: 8px;
  transition: background 0.2s, color 0.2s;
}

.nav-text.active {
  color: #2d81fe;
}

.nav-text:hover {
  background: #f8fafc;
}

.login-box {
  display: flex;
  align-items: center;
}

.login-button1 {
  font-family: "HarmonyOS Sans SC-Bold";
  display: flex;
  align-items: center;
  height: 38px;
  padding: 0 12px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  color: #1f2937;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}

.login-button1:hover {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
}

.avatar-icon {
  width: 18px;
  height: 18px;
  margin-right: 4px;
}

.login-button2 {
  font-family: "HarmonyOS Sans SC-Bold";
  margin-left: 8px;
  height: 38px;
  padding: 0 22px;
  background: #3b82f6;
  border-radius: 8px;
  border: 1px solid #3b82f6;
  cursor: pointer;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
}

.login-button2:hover {
  background: #2563eb;
  border: 1px solid #2563eb;
}

.main-content {
  box-sizing: border-box;
  width: 100%;
  /* height: calc(100vh - 80px); */
}

.main-content-box {
  /* padding-left: 120px;
  padding-top: 44px;
  margin-top: 44px; */
}

.tab-buttons {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.tab-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 32px;
}

.tab-buttons button {
  font-size: 20px;
  font-weight: 500;
  color: #98a2b3;
  border: 0px;
  background-color: #fff;
  padding: 0px;
  margin-bottom: 8px;
}

.active {
  color: #2d81fe;
}

.tab-buttons button.active {
  color: #2d81fe;
}

.tab-buttons .active1 {
  width: 25px;
  height: 2px;
}

.tab-buttons .active2 {
  width: 25px;
  height: 2px;
  background-color: #2d81fe;
}

.introduction {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-right: 120px;
  margin-bottom: 26px;
}

.introduction-left {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
}

.left-text1 {
  font-size: 48px;
  line-height: 60px;
  font-weight: 900;
  color: #101828;
  text-align: start;
  margin-top: 50px;
  margin-bottom: 24px;
}

.left-text2 {
  font-size: 18px;
  line-height: 28px;
  font-weight: 400;
  color: #98a2b3;
  text-align: start;
}

/* .section-box {
  border: 1px solid #ddd;
  padding: 1rem;
  margin-bottom: 1.5rem;
  background: #f9f9f9;
  text-align: left;
} */

.list-box {
  margin-top: 64px;
}

.introduction-List {
  list-style: none;
  padding: 0;
  margin: 0;
}

.introduction-List img {
  width: 24px;
  height: 24px;
}

.introduction-box {
  display: flex;
  justify-content: flex-start;
  align-items: top;
  margin-bottom: 28px;
}

.introduction-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
  text-align: left;
  margin-left: 16px;
}

.introduction-text div:nth-child(1) {
  font-size: 16px;
  color: #344054;
  font-weight: bold;
}

.introduction-text div:nth-child(2) {
  font-size: 16px;
  color: #98a2b3;
  font-weight: 500;
  margin-top: 8px;
}

.introduction-right img {
  width: 600px;
  height: 600px;
}

.tab-text {
  font-size: 20px;
  color: #98a2b3;
}

.section-box h3 {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.footer {
  background: #333;
  color: #fff;
  text-align: center;
  padding: 1rem;
}

.nav1 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  float: left;
}

.nav_content {
  height: 100%;
  width: 290px;
  list-style: none;
  text-align: left;
  padding: 0px 20px;

  li {
    position: relative;
    width: 250px;
    height: 56px;
    line-height: 56px;
    padding-left: 30px;

    a {
      width: 64px;
      height: 24px;
      font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
      font-weight: 500;
      font-size: 16px;
      color: #101828;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

  li.selected::before {
    content: "";
    position: absolute;
    left: 12px;
    /* 竖杠的位置 */
    top: 18px;
    bottom: 18px;
    width: 3px;
    background-color: #2d81fe;
    /* 竖杠的颜色 */
    display: block;
  }

  li:hover {
    background: #eef6ff;
  }
}

a {
  text-decoration: none;
  color: black;
}

#page_content {
  width: calc(100% - 290px);
  border-left: 1px solid #eaecf0;
}

.advantage {
  width: 100%;
  padding-top: 44px;
}

.advantage-title {
  font-weight: 900;
  font-size: 48px;
  color: #000000;
  line-height: 60px;
  text-align: left;
}

.advantage-box1 {
  width: 100%;
  height: 335px;
  background: #f9fafb;
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #eaecf0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;
  padding-bottom: 16px;
  margin-top: 32px;
}

.advantage-box1 .middle-box {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 145px;
  padding-right: 145px;
}

.middle-box .small-box {
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.middle-box .small-box img {
  width: 18px;
  height: 18px;
  margin-top: 8px;
  margin-bottom: 10px;
}

.middle-box .small-box span {
  font-weight: 500;
  font-size: 16px;
  color: #98a2b3;
  line-height: 24px;
  text-align: center;
}

.tab-content {
  width: 100%;
  padding-right: 120px;
}

.advantage-box2 {
  width: 100%;
  height: 532px;
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
}

.box2-left {
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.left1,
.left2 {
  width: 100%;
  height: 250px;
  background: #f9fafb;
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #eaecf0;
}

.box2-right {
  flex: 1;
  height: 532px;
  background: #f9fafb;
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #eaecf0;
  margin-left: 32px;
}

.contact-box {
  margin-top: 50px;
  margin-left: 90px;
  text-align: left;
}

.contact-title {
  width: 720px;
  height: 44px;
  font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
  font-weight: 400;
  font-size: 36px;
  color: #101828;
  line-height: 44px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.contact-line {
  margin-top: 30px;
}

.contact-text {
  width: 720px;
  height: 24px;
  font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
  font-weight: 500;
  font-size: 16px;
  color: #344054;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.icon {
  width: 96px;
  height: 96px;
  margin-top: 32px;
}

.span1 {
  font-weight: bold;
  font-size: 20px;
  color: #344054;
  line-height: 30px;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 8px;
}

.span2 {
  font-weight: 500;
  font-size: 16px;
  color: #98a2b3;
  line-height: 24px;
  text-align: center;
}

.left1,
.left2,
.box2-right {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 32px;
  padding-right: 32px;
}

.box2-right {
  justify-content: center;
}

.application {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
}

.application-box {
  width: 100%;
  display: flex;
  margin-top: 32px;
  justify-content: center;
}

.application-info-icon {
  width: 102px;
  height: 119px;
}

.application-smallbox {
  width: 49%;
  background: #f9fafb;
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #eaecf0;
  padding-top: 101px;
  padding-bottom: 101px;
}

.application-text1 {
  box-sizing: border-box;
  width: 100%;
  padding-left: 126px;
  padding-right: 126px;
  font-weight: 400;
  font-size: 18px;
  color: #344054;
  line-height: 28px;
  margin-top: 76px;
}

.application-smallbox .text1 {
  font-weight: bold;
  font-size: 60px;
  color: #101828;
  line-height: 72px;
  text-align: center;
  margin-top: 101px;
}

.application-smallbox .text2 {
  font-weight: 500;
  font-size: 22px;
  color: #101828;
  line-height: 34px;
  text-align: left;
  margin-top: 32px;
  cursor: pointer;
}

.application-smallbox .text2:hover {
  background: #f2f4f7;
  border: 1px solid #eaecf0;
}

.application-box .text2-box {
  width: 100%;
  box-sizing: border-box;
  padding-left: 112px;
  padding-right: 112px;
  display: flex;
  justify-content: space-between;
}

.application-box .text2 {
  width: 135px;
  height: 68px;
  background: #ffffff;
  border-radius: 9px 9px 9px 9px;
  border: 1px solid #eaecf0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.appliacation-text2 {
  width: 100%;
  font-weight: bold;
  font-size: 48px;
  color: #101828;
  line-height: 60px;
  text-align: center;
  margin-top: 128px;
  margin-bottom: 48px;
}

.grid-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
}

.box-item {
  width: 6.3%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 62px;
  margin-right: 9.3%;
}

.introduction-bottom-doc {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 563px;
}

.introduction-bottom-doc0 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 18px;
}

.introduction-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 94px;
}

.introduction-bottom42 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 42px;
}

.beian-icon {
  width: 20.65px;
  height: 24.09px;
  cursor: pointer;
}

.beian-text {
  font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
  font-weight: 400;
  font-size: 12px;
  color: #303030;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 8px;
}

.grid-box .box-item:nth-child(7) {
  margin-right: 0;
}

.grid-box .box-item:nth-child(14) {
  margin-right: 0;
}

.grid-box .box-item:nth-child(21) {
  margin-right: 0;
}

.box-item img {
  width: 80px;
  height: 80px;
  border-radius: 13px 13px 13px 13px;
  border: 1px solid #eaecf0;
}

.box-item span {
  font-weight: 500;
  font-size: 20px;
  color: #344054;
  line-height: 30px;
  text-align: center;
  margin-top: 9px;
  white-space: nowrap;
}

.pdf-container {
  height: 78vh;
  width: 100%;
  background: white;
  position: relative;
  overflow: hidden;
}

/* 隐藏链接下划线和颜色 */
span:hover,
a:hover {
  cursor: pointer;
  text-decoration: none;
  color: inherit;
}

/* Optional: Adjust nav-text style for dropdown trigger */
/*
.nav-text .el-icon--right {
  margin-left: 4px;
}
*/

.nav-item-dropdown {
  position: relative;
}

.nav-item-dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  list-style: none;
  padding: 8px;
  margin-top: 10px;
  border-radius: 8px;
  min-width: 160px;
  text-align: left;
  color: #1f2937;
}

.nav-item-dropdown::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -10px;
  height: 10px;
  background: transparent;
}

.dropdown-menu li {
  margin: 0;
  padding: 0;
}

.dropdown-item {
  display: block;
  padding: 8px 12px;
  color: #1f2937;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  border-radius: 8px;
}

.dropdown-item:hover {
  background: #f3f4f6;
}

.menu-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;
  display: flex;
}
.menu-container .left {
  width: calc(100vw - 70px);
  height: 100%;
  background-color: #fff;
  padding: 0 16px;
}
.menu-container .right {
  width: 70px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

.top-box {
  width: 100%;
  padding: 24px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
}

.top-box-right > img {
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin-right: 16px;
}

.back_box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  padding: 8px 0;
}

.back_img {
  width: 16px;
  height: 16px;
}

.back_text {
  margin-left: 8px;
  width: 70px;
  height: 20px;
  font-family: "HarmonyOS Sans SC-Medium";
  font-weight: 500;
  font-size: 14px;
  color: #1f2937;
  line-height: 20px;
}

.search_input {
  margin-top: 20px;
}

.footer_all {
  width: 100vw;
  /* height: 236px;  */
  background-color: #1e293b;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 36px 0;
}

.webMap {
  width: fit-content;
  display: flex;
  align-items: center;
}

.webMap > .left {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.webMap > .left > img {
  margin: 12px 32px 12px 0;
}

.webMap > .right {
  display: flex;
  flex-direction: column;
}

.webMap > .right > .platform {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.platform-text {
  font-family: "HarmonyOS Sans SC-Regular";
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.5);
  text-align: left;
}

.wechat {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wechat-text {
  font-family: "HarmonyOS Sans SC-Regular";
  font-weight: 400;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  text-align: left;
  margin-top: 6px;
}

.recordNumber {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
}

.footer_text {
  font-family: "HarmonyOS Sans SC-Regular";
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  opacity: 0.5;
  text-align: left;
  margin-left: 8px;
}
</style>

<style>
.filter-tree {
  font-family: "HarmonyOS Sans SC-Medium", sans-serif;
}
</style>
